"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logoutUser = exports.authenticateUser = void 0;
const tslib_1 = require("tslib");
const authentication_service_1 = require("./authentication-service");
let userRequested = false;
let numberAuthentication = 0;
const isRequireSignin = (oidcUser, isForce) => isForce || !oidcUser;
const authenticateUser = (userManager, location, history, user = null) => (isForce = false, callbackPath = null) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    let oidcUser = user;
    if (!oidcUser) {
        oidcUser = yield userManager.getUser();
    }
    if (userRequested) {
        return;
    }
    numberAuthentication++;
    const url = callbackPath || location.pathname + (location.search || '');
    if (isRequireSignin(oidcUser, isForce)) {
        userRequested = true;
        try {
            yield userManager.signinRedirect({ data: { url } });
        }
        catch (error) {
            authentication_service_1.removeUserManager();
            throw error;
        }
        finally {
            userRequested = false;
        }
    }
    else if (oidcUser === null || oidcUser === void 0 ? void 0 : oidcUser.expired) {
        userRequested = true;
        try {
            yield userManager.signinSilent();
        }
        catch (error) {
            if (numberAuthentication <= 1) {
                yield userManager.signinRedirect({ data: { url } });
            }
            else {
                userRequested = false;
                history.push(`/authentication/session-lost?path=${encodeURI(url)}`);
            }
        }
        userRequested = false;
    }
});
exports.authenticateUser = authenticateUser;
const logoutUser = (userManager) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const oidcUser = yield userManager.getUser();
    if (oidcUser) {
        yield userManager.signoutRedirect();
    }
});
exports.logoutUser = logoutUser;
//# sourceMappingURL=oidc-service.js.map